import {
    buildExperimentGroupTaskTemplatesAPI,
    buildSchemaConfigTaskTemplatesAPI,
} from "@/services/api.services";
import { SavedObject } from "@/services/commonModels";

export type BaseTaskTemplate = {
    protocolCode: string | null;
    schemaConfigId: string | null;
    experimentGroupId: string | null;
    day: number | null;
    taskGroupId: string;
    readoutGroupId: string;
};

export type SavedBaseTaskTemplate = BaseTaskTemplate & SavedObject<string>;

export type SchemaConfigTaskTemplate = BaseTaskTemplate & {
    schemaConfigId: string;
};

export type SavedSchemaConfigTaskTemplate = SavedBaseTaskTemplate & SchemaConfigTaskTemplate;

export type ExperimentGroupTaskTemplate = BaseTaskTemplate & {
    experimentGroupId: string;
};

export type SavedExperimentGroupTaskTemplate = SavedBaseTaskTemplate & ExperimentGroupTaskTemplate;

export const taskTemplatesAPI = {
    bySchemaConfig: (schemaConfigId: string) => {
        return buildSchemaConfigTaskTemplatesAPI(schemaConfigId);
    },
    byExperimentGroup: (experimentGroupId: string) => {
        return buildExperimentGroupTaskTemplatesAPI(experimentGroupId);
    },
};
